import { useEffect } from 'react';
import { useStateChangeGuard } from './useStateChangeGuard';

/**
 * In development, if React Strict Mode is enabled, effects run twice.
 * This is useful to detect bugs.
 * However, we need to prevent double-transition to the same state:
 * https://doxyme.atlassian.net/browse/CS-12701
 */
export const useStateChangeEffect = <T extends string>(
  onChange: (state: T) => Promise<void>,
  state: T,
): void => {
  const checkDidStateChange = useStateChangeGuard<T>();

  useEffect(() => {
    if (checkDidStateChange(state)) {
      void onChange(state);
    }
  }, [checkDidStateChange, state]);
};
